const SELECTOR = '.product-fieldset';
const EVENT = 'provider_listing_position';
const PUSH_GAP_MS = 350; // GTM setup tag needs time between each GA4 hit

function uniqueProviders(pageTypeValue) {
    const seen = new Set();
    const list = [];

    document.querySelectorAll(SELECTOR).forEach((provider) => {
        const position = provider.dataset.order || 'single';
        const serviceProvider = provider.dataset.productname || 'no productname';
        const key = `${position}:${serviceProvider}`;

        if (seen.has(key)) {
            return;
        }

        seen.add(key);
        list.push({ position, pageType: pageTypeValue, serviceProvider });
    });

    return list;
}

function pushEvent(provider) {
    const payload = { event: EVENT, ...provider };

    console.log(payload);
    window.dataLayer.push(payload);
}

function sendAll(providers) {
    providers.forEach((provider, index) => {
        setTimeout(() => pushEvent(provider), index * PUSH_GAP_MS);
    });
}

function whenReady() {
    const pageLoaded = document.readyState === 'complete'
        ? Promise.resolve()
        : new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));

    return pageLoaded.then(() => window.slGoogleDataFetcher?.analyticsPromise);
}

export default function init() {
    if (window.tslProviderListingTracked) {
        return;
    }

    window.tslProviderListingTracked = true;

    const pageTypeField = document.getElementById('pagetype');
    const pageTypeValue = pageTypeField ? pageTypeField.value : 'generic';

    whenReady().then(() => {
        const providers = uniqueProviders(pageTypeValue);

        if (providers.length) {
            sendAll(providers);
        }
    });
}
